export enum AuthType {
  LOGIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  ABOUT,
  CHANGE_EMAIL,
}
